import type ItemId from 'owa-service/lib/contract/ItemId';

export const getReadRibbonId = (baseId: number | string, itemId?: ItemId): number | string => {
    return itemId ? `${baseId}_${itemId.Id}` : baseId;
};
